import {
    AutoComplete as DMSAutoCompleteControl,
    BaseDropDownControl as DMSBaseDropDownControl,
    Button as DMSButtonControl,
    Checkbox as DMSCheckboxControl,
    ColorPicker as DMSColorPickerControl,
    ComboBox as DMSComboBoxControl,
    ContextMenu as DMSContextMenuControl,
    Custom as DMSCustomControl,
    DatabaseImage as DMSDatabaseImageControl,
    Date as DMSDateControl,
    DateTime as DMSDateTimeControl,
    FileUpload as DMSFileUploadControl,
    HiddenDate as DMSHiddenDateControl,
    HiddenText as DMSHiddenTextControl,
    HtmlEditor as DMSHtmlEditorControl,
    Image as DMSImageControl,
    Link as DMSLinkControl,
    List as DMSListControl,
    MaskedTextBox as DMSMaskedTextBoxControl,
    MultiSelect as DMSMultiSelectControl,
    Number as DMSNumberControl,
    RtfEditor as DMSRtfEditorControl,
    TextBlock as DMSTextBlockControl,
    Text as DMSTextControl,
    ThreeStateCheckbox as DMSThreeStateCheckboxControl,
    Time as DMSTimeControl,
} from "./index";

/**
 * ## Controls
 * List of all standard controls.
 *
 * Please use the links below to navigate to the documentation of each control.
 */
export namespace Controls {
    /**
     * Click {@link AutoCompleteControl|here} for the documentation of AutoComplete.
     */
    export const AutoCompleteControl = DMSAutoCompleteControl;
    /**
     * Click {@link BaseDropDownControl|here} for the documentation of BaseDropDown.
     */
    export const BaseDropDownControl = DMSBaseDropDownControl;
    /**
     * Click {@link ButtonControl|here} for the documentation of Button.
     */
    export const ButtonControl = DMSButtonControl;
    /**
     * Click {@link CheckboxControl|here} for the documentation of Checkbox.
     */
    export const CheckboxControl = DMSCheckboxControl;
    /**
     * Click {@link ColorPickerControl|here} for the documentation of ColorPicker.
     */
    export const ColorPickerControl = DMSColorPickerControl;
    /**
     * Click {@link ComboBoxControl|here} for the documentation of ComboBox.
     */
    export const ComboBoxControl = DMSComboBoxControl;
    /**
     * Click {@link ContextMenuControl|here} for the documentation of ContextMenu.
     */
    export const ContextMenuControl = DMSContextMenuControl;
    /**
     * Click {@link CustomControl|here} for the documentation of Custom.
     */
    export const CustomControl = DMSCustomControl;
    /**
     * Click {@link DatabaseImageControl|here} for the documentation of DatabaseImage.
     */
    export const DatabaseImageControl = DMSDatabaseImageControl;
    /**
     * Click {@link DateControl|here} for the documentation of Date.
     */
    export const DateControl = DMSDateControl;
    /**
     * Click {@link DateTimeControl|here} for the documentation of DateTime.
     */
    export const DateTimeControl = DMSDateTimeControl;
    /**
     * Click {@link FileUploadControl|here} for the documentation of FileUpload.
     */
    export const FileUploadControl = DMSFileUploadControl;
    /**
     * Click {@link HiddenDateControl|here} for the documentation of HiddenDate.
     */
    export const HiddenDateControl = DMSHiddenDateControl;
    /**
     * Click {@link HiddenTextControl|here} for the documentation of HiddenText.
     */
    export const HiddenTextControl = DMSHiddenTextControl;
    /**
     * Click {@link HtmlEditorControl|here} for the documentation of HtmlEditor.
     */
    export const HtmlEditorControl = DMSHtmlEditorControl;
    /**
     * Click {@link ImageControl|here} for the documentation of Image.
     */
    export const ImageControl = DMSImageControl;
    /**
     * Click {@link LinkControl|here} for the documentation of Link.
     */
    export const LinkControl = DMSLinkControl;
    /**
     * Click {@link ListControl|here} for the documentation of List.
     */
    export const ListControl = DMSListControl;
    /**
     * Click {@link MaskedTextBoxControl|here} for the documentation of MaskedTextBox.
     */
    export const MaskedTextBoxControl = DMSMaskedTextBoxControl;
    /**
     * Click {@link MultiSelectControl|here} for the documentation of MultiSelect.
     */
    export const MultiSelectControl = DMSMultiSelectControl;
    /**
     * Click {@link NumberControl|here} for the documentation of Number.
     */
    export const NumberControl = DMSNumberControl;
    /**
     * Click {@link RtfEditorControl|here} for the documentation of RtfEditor.
     */
    export const RtfEditorControl = DMSRtfEditorControl;
    /**
     * Click {@link TextBlockControl|here} for the documentation of TextBlock.
     */
    export const TextBlockControl = DMSTextBlockControl;
    /**
     * Click {@link TextControl|here} for the documentation of Text.
     */
    export const TextControl = DMSTextControl;
    /**
     * Click {@link ThreeStateCheckboxControl|here} for the documentation of ThreeStateCheckbox.
     */
    export const ThreeStateCheckboxControl = DMSThreeStateCheckboxControl;
    /**
     * Click {@link TimeControl|here} for the documentation of Time.
     */
    export const TimeControl = DMSTimeControl;
}
